import React from "react";
import { Select, TextField, Section } from "components/shared";
import { fetchStateAttributes } from 'utils/api/vet_practice_attributes';

const ErrorMessage = (props) => (
  <div className="error-text-clinical" {...props}>
    {props.children}
  </div>
);

const AustraliaMessage = () => (
  <div className="forward-to-advisor-text">
    <p >
      Thank you for your interest in becoming a reseller in Australia. Please call a Platinum Advisor
      at 1-800-553-2400 or email us at{" "}
      <a
        href="mailto:clients@platinumperformance.com"
        target="_blank"
      >
        clients@platinumperformance.com{" "}
      </a>
      and ask for our Veterinary Resellers Agreement.
      Our online form is not yet available for Australia.
    </p>
  </div>
)

const countrySelectErrorMessage = (selectedCountry) => {
  if (selectedCountry === "Other") {
    return (
      <ErrorMessage sectionComponentSize="large">
        <p>
          We're sorry, but at this time we do not have a reseller program in
          your area. Please feel free to send us a message on our{" "}
          <a
            href="https://www.platinumperformance.com/horses-international"
            target="_blank"
          >
            International Distributors{" "}
          </a>
          page if you'd like to express your interest in our reseller program.
        </p>
      </ErrorMessage>
    )
  }

  if (selectedCountry === "Australia") {
    return <AustraliaMessage sectionComponentSize="large"/>
  }

  return null
}

export const AddressForm = ({
  countryOptions,
  hideCountry,
  addressType,
  address1,
  address2,
  city,
  state,
  zip,
  country,
  errorText,
  onChange,
  onBlur,
  header
}) => {

  const [stateOptions, setStateOptions] = React.useState([]);
  const invalidCountry = country === "Other" || country === "Australia";

  React.useEffect(() => {
    fetchStateAttributes().then((response) => {
      setStateOptions(response[country]);
    });
  }, [country]);

  const showError = (field) => {
    return (
      !invalidCountry &&
      errorText(field) &&
      errorText(field).length > 0
    );
  }

  let nonCountryFields = [
    <TextField
      name={`${addressType}Address1`}
      variant="outlined"
      label="Address 1"
      disabled={invalidCountry}
      required
      errorMessage={
        !invalidCountry && errorText(`${addressType}Address1`)
      }
      error={showError(`${addressType}Address1`)}
      value={address1}
      onChange={onChange}
      onBlur={onBlur}
    />,
    <TextField
      name={`${addressType}Address2`}
      variant="outlined"
      label="Address 2"
      disabled={invalidCountry}
      errorMessage={
        !invalidCountry && errorText(`${addressType}Address2`)
      }
      error={showError(`${addressType}Address2`)}
      value={address2}
      onChange={onChange}
      onBlur={onBlur}
    />,
    <TextField
      sectionComponentSize="medium"
      name={`${addressType}City`}
      variant="outlined"
      label="City"
      required
      disabled={invalidCountry}
      errorMessage={
        !invalidCountry && errorText(`${addressType}City`)
      }
      error={showError(`${addressType}City`)}
      value={city}
      onChange={onChange}
      onBlur={onBlur}
    />,
    <Select
      sectionComponentSize="small"
      name={`${addressType}State`}
      value={state}
      label="State/Province/Region"
      required
      disabled={invalidCountry}
      errorMessage={
        !invalidCountry && errorText(`${addressType}State`)
      }
      error={showError(`${addressType}State`)}
      onChange={onChange}
      options={stateOptions || []}
      onBlur={onBlur}
    />,
    <TextField
      sectionComponentSize="small"
      name={`${addressType}Zip`}
      variant="outlined"
      label="Zip/Postal Code"
      required
      disabled={invalidCountry}
      errorMessage={
        !invalidCountry && errorText(`${addressType}Zip`)
      }
      error={showError(`${addressType}Zip`)}
      value={zip}
      onChange={onChange}
      onBlur={onBlur}
    />
  ]


  const countrySelect = <Select
    style={{display: 'none'}}
    sectionComponentSize="large"
    name={`${addressType}Country`}
    value={country}
    label="Country"
    required
    errorMessage={errorText(`${addressType}Country`)}
    error={showError(`${addressType}Country`)}
    onChange={onChange}
    onBlur={onBlur}
    // The countries and their labels happen to be identical at the moment,
    // We can determine the label differently in the future when this changes
    options={countryOptions.map((country) => ({ value: country, label: country }))}
  />

  let componentList;

  if (hideCountry) {
    componentList = nonCountryFields
  } else {
    const countryComponents = [countrySelect]

    // Conditionally render error component beneath country in Section
    if (invalidCountry) countryComponents.push(countrySelectErrorMessage(country));

    componentList = [...countryComponents, ...nonCountryFields]
  }

  return (
    <Section
      title={header}
      components={componentList}
    />
  );
};
